import { ITabsData } from '../../../hooks/useTabItemsState';
import { FunctionBlockStateEnum } from './types';

export const errorTabState: Partial<ITabsData<FunctionBlockStateEnum>> = {
  icon: {
    asset: 'ErrorDot',
  },
  error: true,
};
